import React, {useContext} from "react";
import "./Footer.scss";
import {Fade} from "react-reveal";
import emoji from "react-easy-emoji";
import StyleContext from "../../contexts/StyleContext";

export default function Footer() {
  const {isDark} = useContext(StyleContext);
  return (
    <Fade bottom duration={1000} distance="5px">
      <div className="footer-div">
        <p className={isDark ? "dark-mode footer-text" : "footer-text"}>
          {emoji("Made with ❤️ by ")}
          <a
            href="https://t.me/CodeSib"
            target="_blank"
            rel="noreferrer"
            style={{color: '#0066cc', textDecoration: 'underline'}}
          >
            Лопухов Александр
          </a>
        </p>
        <p className={isDark ? "dark-mode footer-text" : "footer-text"}>
          <a
            href="https://t.me/CodeSib"
            target="_blank"
            rel="noreferrer"
            style={{color: '#0088cc', textDecoration: 'none'}}
          >
            <i className="fab fa-telegram" style={{marginRight: '8px'}}></i>
            Telegram: @CodeSib
          </a>
        </p>
      </div>
    </Fade>
  );
}
